import styled from "styled-components";

export const Container = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  background:
    radial-gradient(circle at top left, rgba(193, 168, 120, 0.22), transparent 34%),
    linear-gradient(135deg, rgba(74, 41, 52, 0.97) 0%, rgba(99, 56, 71, 0.95) 46%, rgba(128, 74, 92, 0.92) 100%);
  color: #f7f2eb;
  overflow: hidden;
`;

export const BackdropImage = styled.div`
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(51, 26, 35, 0.84) 10%, rgba(51, 26, 35, 0.54) 44%, rgba(51, 26, 35, 0.84) 100%),
    url("${({ image }) => image}") center top / cover no-repeat;
  opacity: 0.9;
  transform: scale(1.05);
`;

export const Glow = styled.div`
  position: absolute;
  border-radius: 999px;
  filter: blur(12px);
  opacity: 0.7;

  &.top {
    width: 22rem;
    height: 22rem;
    right: -6rem;
    top: -8rem;
    background: rgba(201, 177, 132, 0.18);
  }

  &.bottom {
    width: 18rem;
    height: 18rem;
    left: -5rem;
    bottom: -6rem;
    background: rgba(183, 118, 144, 0.2);
  }
`;

export const Inner = styled.div`
  position: relative;
  z-index: 1;
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
  padding: 148px 0 92px;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  gap: 32px;
  align-items: end;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
    padding-top: 132px;
    gap: 28px;
  }

  @media (max-width: 720px) {
    width: min(100% - 32px, 1240px);
    padding-top: 116px;
    padding-bottom: 64px;
  }
`;

export const HeroContent = styled.div`
  max-width: 680px;
`;

export const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 16px 38px rgba(58, 30, 40, 0.28);
  backdrop-filter: blur(12px);
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #f3e5c5;
`;

export const Title = styled.h1`
  margin: 20px 0 16px;
  font-family: "Cormorant Garamond", "Times New Roman", serif;
  font-size: clamp(3.5rem, 7vw, 4rem);
  line-height: 0.94;
  letter-spacing: -0.03em;
  color: #fffaf4;
`;

export const Subtitle = styled.p`
  max-width: 600px;
  margin: 0;
  font-size: clamp(1rem, 1.6vw, 1.18rem);
  line-height: 1.85;
  color: rgba(247, 242, 235, 0.82);
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 30px;
`;

export const PrimaryButton = styled.button`
  min-height: 54px;
  padding: 0 24px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #d1b07a 0%, #c19b63 100%);
  color: #4d2934;
  font-weight: 700;
  font-size: 0.98rem;
  cursor: pointer;
  box-shadow: 0 18px 40px rgba(193, 155, 99, 0.26);
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 24px 48px rgba(193, 155, 99, 0.3);
    filter: brightness(1.03);
  }
`;

export const SecondaryButton = styled.a`
  min-height: 54px;
  padding: 0 24px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  color: #f6efe6;
  font-weight: 700;
  font-size: 0.98rem;
  text-decoration: none;
  backdrop-filter: blur(12px);
  transition: transform 180ms ease, background 180ms ease, border-color 180ms ease;

  &:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.28);
  }
`;

export const Metrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-top: 36px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const MetricCard = styled.div`
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 22px;
  background: rgba(67, 35, 46, 0.44);
  box-shadow: 0 18px 40px rgba(53, 26, 35, 0.24);
  backdrop-filter: blur(10px);
`;

export const MetricValue = styled.div`
  font-family: "Cormorant Garamond", "Times New Roman", serif;
  font-size: 2rem;
  line-height: 1;
  color: #fff5e6;
`;

export const MetricLabel = styled.div`
  margin-top: 8px;
  font-size: 0.95rem;
  line-height: 1.55;
  color: rgba(247, 242, 235, 0.72);
`;

export const SidePanel = styled.div`
  justify-self: end;
  width: min(100%, 430px);
  padding: 26px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(248, 243, 236, 0.12) 0%, rgba(248, 243, 236, 0.04) 100%);
  box-shadow: 0 28px 60px rgba(53, 26, 35, 0.3);
  backdrop-filter: blur(14px);

  @media (max-width: 1080px) {
    justify-self: start;
  }

  @media (max-width: 720px) {
    padding: 22px;
  }
`;

export const PanelTag = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 7px 14px;
  border-radius: 999px;
  background: rgba(241, 226, 197, 0.16);
  color: #f3e3c5;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const PanelTitle = styled.h2`
  margin: 18px 0 12px;
  font-family: "Cormorant Garamond", "Times New Roman", serif;
  font-size: clamp(2.1rem, 3.3vw, 2.8rem);
  line-height: 0.98;
  color: #fffaf5;
`;

export const PanelText = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.8;
  color: rgba(247, 242, 235, 0.78);
`;

export const PanelList = styled.div`
  display: grid;
  gap: 14px;
  margin-top: 22px;
`;

export const PanelItem = styled.div`
  padding: 16px 18px;
  border-radius: 18px;
  background: rgba(65, 33, 44, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const PanelItemTitle = styled.div`
  color: #fff5e6;
  font-weight: 700;
  font-size: 0.96rem;
`;

export const PanelItemText = styled.div`
  margin-top: 6px;
  color: rgba(247, 242, 235, 0.7);
  font-size: 0.92rem;
  line-height: 1.65;
`;
